import React from "react";

interface LuzProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconLuz: React.FC<LuzProps> = ({ className, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 21.714" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.648 21.714v-3.429h2.286v3.429zM.362 11.428V9.143h3.429v2.286zm19.429 0V9.143h3.429v2.286zm-1.143 7.886-2.4-2.4 1.6-1.6 2.4 2.4zm-13.714 0-1.6-1.6 2.4-2.4 1.6 1.6zM11.791 16q-2.37 0-4.042-1.672t-1.672-4.042q0-1.371.615-2.557a6.1 6.1 0 0 1 1.67-2.015V0h6.857v5.714a6.1 6.1 0 0 1 1.672 2.015q.614 1.185.614 2.557 0 2.371-1.671 4.042Q14.162 16 11.791 16M10.648 4.686a5.7 5.7 0 0 1 1.143-.114 5.7 5.7 0 0 1 1.143.114v-2.4h-2.286zm1.143 9.029q1.429 0 2.429-1a3.3 3.3 0 0 0 .999-2.429q0-1.429-1-2.429a3.3 3.3 0 0 0-2.428-1q-1.429 0-2.429 1a3.3 3.3 0 0 0-1 2.429q0 1.429 1 2.429a3.3 3.3 0 0 0 2.429 1"
      fill="#C2282B"
    />
  </svg>
);
export default IconLuz;
